/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {getEnvironment} from '../../../utils/Environment';
import {importFileObj} from '../RecentWork/AppHome/EmptyState/PSWebEmptyState';
import getConfig from '../../../config';

const pickerInfo = {
	mode: 'open',
	outputFileFormatChoices: [{label: 'PSDC', extension: 'psdc', mimetype: 'PSDC'}],
	spacesOutputFileFormatChoices: [
		{label: 'PNG', extension: 'png', mimetype: 'PNG'},
		{label: 'SVG', extension: 'svg', mimetype: 'SVG'},
	],
};

const IMSData = {
	accountType: window.adobeIMS?.getUserProfile()?.account_type,
	displayName: window.adobeIMS?.getUserProfile()?.displayName,
	environment: getEnvironment() !== 'prod' ? 'stage' : 'prod',
	subscriptionType: window.adobeIMS?.getUserProfile()?.serviceAccounts && window.adobeIMS?.getUserProfile()?.serviceAccounts[0]?.serviceLevel || '',
	serviceLevel: window.adobeIMS?.getUserProfile()?.serviceAccounts && window.adobeIMS?.getUserProfile()?.serviceAccounts[0]?.serviceLevel || '',
	fetchToken: () => (window.adobeIMS?.getAccessToken()),
	token: window.adobeIMS?.getAccessToken(),
	userEmail: window.adobeIMS?.getUserProfile()?.email,
	fetchUserId: () => (window.adobeIMS?.getUserProfile()?.userId),
	userId: window.adobeIMS?.getUserProfile()?.userId,
};

const hostConfig = {
	apiKey: 'CCHomeWeb1',
	// dcxId: 'CometDesktop3',
	defaultDocumentIcons: {
		// default: './assets/picker/default-file-icon.png',
		defaultTab: '1',
	},
	documentFilter: [
		// 'application/vnd.adobe.xd.cloudproject+dcx',
		'document/vnd.adobe.cpsd+dcx',
		'image/jpeg',
		'image/tiff',
		'image/tif',
		'image/x-png',
		'image/png',
		'image/jpg',
		'image/heic',
		'application/x-photoshop',
		// 'document/vnd.adobe.illustrator+dcx',
	],
	environment: getEnvironment() !== 'prod' ? 'stage' : 'prod',
	featureFlags: {
		cdpTabs: true,
		// set debuggingLogin to true to pause startup so you can debug login without refreshing.
		// In the debugger, set a breakpoint at the test for this flag and set it back to false
		// to proceed.
		debuggingLogin: false,
		disableACPL: true,
		disableCloudDocPrefetch: true,
		disableRecentsTab: true,
		disableSharedWithYouTab: false,
		hideCloudStatusIcon: false,
		emptyViewLoggedOutMessage: true,
		enableAssetRef: false,
		enableCDPOnboarding: false,
		enableCloudDocCopy: false,
		enableCloudDocExport: false,
		enableCloudDocImport: true,
		enableCloudDocFolders: true,
		enableCloudDocMultiSelectOpen: false,
		enableCloudDocPinning: true,
		enableCloudDocRename: true,
		enablePlaceEmbedWarningToast: false,
		enableProjects: true,
		enableCloudFiles: false,
		enableSAM: false,
		openShareSheet: false,
		focusManagementEnabled: true,
		registerUserWithACPL: false, // set to true to test acp-fetch on uxp
		useAdobeReactVirtualized: false,
		useCDPDeletedTab: true,
		useOrganizerMode: false,
		enableFilter: true,
		isLinkMode: false,
		disableLinkCheckbox: false,
		useCCDmode: false,
		enableDragDrop: true,
		enableImportDrop: true,
		enableRenditionUrl: true,
	},
	locale: window.cchome.util.getStartupLanguage(),
	onboardingHelpJumpToken: null,
	platform: 'web',
	productBuildNumber: '',
	productId: 'CCHome',
	platformVersion: '',
	productLocation: '',
	productName: 'CCHome',
	productVersion: '1.0.0',
	uiLocale: window.cchome.util.getStartupLanguage(),
};

let closeDialog = () => {};
const uapCallbacks = {
	onOpenDocuments: (docInfoArray): void => {
		closeDialog();
		const targetHostname = getConfig('PHOTOSHOP_WEB');
		window.location.href = `${targetHostname}/id/${docInfoArray[0].cloudID}`;
		// console.log(docInfoArray);
	},
	onExecutePickerAction: (actionState: {}) => {
		closeDialog();
		if (actionState.action === 'switchToOSPicker') {
			importFileObj.handleFileSelect(null, null);
		}
		// console.log(actionState);
	},
	onPlaceDocuments: (docInfoArray): void => {
		closeDialog();
		// console.log(docInfoArray);
	},
	onImportPlaceDocuments: (docInfoArray): void => {
		closeDialog();
		// console.log(docInfoArray);
	},
	onPlaceLinkOrEmbedDocuments: (docInfoArray, isLink: boolean): void => {
		closeDialog();
		// console.log(docInfoArray,isLink);
		// const action = isLink ? 'Place Linked: ' : 'Place Embedded: ';

	},
	onGetLocalRecents: (): Promise<any> =>
	// console.log("callbacks.onGetLocalRecents called");
		Promise.resolve([]),

};

class FilePicker {
	static _instance: any;
	fileSelector: any;

	constructor() {
		if (FilePicker._instance) {
			return FilePicker._instance;
		}
		FilePicker._instance = this;

	}

	showFilePicker() {
		import(/* webpackChunkName: "documentPicker" */ '@ccx/ccx-document-picker').then(
			(ccxDocumentPickerLib) => {
				closeDialog = ccxDocumentPickerLib.showPicker(pickerInfo, hostConfig, uapCallbacks, IMSData, 'light', document.body);
			},
		);
	}


}

export const filePickerObj = new FilePicker();
